import script from "./Ordercenter.vue?vue&type=script&setup=true&lang=js"
export * from "./Ordercenter.vue?vue&type=script&setup=true&lang=js"

import "./Ordercenter.vue?vue&type=style&index=0&id=31140b46&lang=less"

const __exports__ = script;

export default __exports__